import { Box, styled } from "@mui/material";

export const FeaturedTrackDeleteModalBody = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
});
